import type { RouteObject } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import Home from '@/pages/home/page';
import SugargooSpreadsheetGuide from '@/pages/article/sugargoo-spreadsheet-guide/page';
import SugargooReview from '@/pages/article/sugargoo-review-2026/page';
import SugargooShippingCost from '@/pages/article/sugargoo-shipping-cost-guide/page';
import SugargooCouponDiscount from '@/pages/article/sugargoo-coupon-discount-guide/page';
import SugargooWarehouse from '@/pages/article/sugargoo-warehouse-guide/page';
import IsSugargooLegit from '@/pages/article/is-sugargoo-legit/page';
import SugargooBeginners from '@/pages/article/sugargoo-spreadsheet-beginners/page';
import SugargooShoes from '@/pages/article/sugargoo-spreadsheet-shoes-finds/page';
import SugargooAlternatives from '@/pages/article/sugargoo-vs-alternatives/page';
import SugargooQCPhotos from '@/pages/article/sugargoo-qc-photos-guide/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/sugargoo-spreadsheet-ultimate-guide',
    element: <SugargooSpreadsheetGuide />,
  },
  {
    path: '/sugargoo-review-2026',
    element: <SugargooReview />,
  },
  {
    path: '/sugargoo-shipping-cost-guide',
    element: <SugargooShippingCost />,
  },
  {
    path: '/sugargoo-coupon-discount-guide',
    element: <SugargooCouponDiscount />,
  },
  {
    path: '/sugargoo-warehouse-guide',
    element: <SugargooWarehouse />,
  },
  {
    path: '/is-sugargoo-legit',
    element: <IsSugargooLegit />,
  },
  {
    path: '/sugargoo-spreadsheet-beginners',
    element: <SugargooBeginners />,
  },
  {
    path: '/sugargoo-spreadsheet-shoes-finds',
    element: <SugargooShoes />,
  },
  {
    path: '/sugargoo-vs-alternatives',
    element: <SugargooAlternatives />,
  },
  {
    path: '/sugargoo-qc-photos-guide',
    element: <SugargooQCPhotos />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;